<template>
  <div class="investor-logs padding-top-20">
    <el-table :data="logs">
      <el-table-column label="Date">
        <template slot-scope="log">
          {{ log.ts | date('Y-MM-DD HH:mm') }}
        </template>
      </el-table-column>

      <el-table-column label="State">
        <template slot-scope="scope">
          {{ scope.row.state | stateLabel }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  filters: { stateLabel },
  computed: {
    ...mapState({
      investor: (state) => state.investorProfile.investor,
      logs: (state) => state.investorLogs.logs,
    }),
  },

  methods: {
    async created() {
      const investorId = this.investor.id
      if (this.$route.params.startupId) {
        const startupId = this.$route.params.startupId
        this.$store.dispatch('investorLogs/fetch', { investorId, startupId })
      } else {
        const user = await this.$store.dispatch('user/getUser')
        if (user.isStartup && user.startup && user.startup.id) {
          const startupId = user.startup.id
          this.$store.dispatch('investorLogs/fetch', { investorId, startupId })
        }
      }
    },
  },
}

function stateLabel(state) {
  return (
    {
      applied: 'Applied',
      invited: 'Invited for screening',
      screening: 'Screening',
      interested: 'Investor is interested',
      not_interested: 'Investor is not interested',
    }[state] || state
  )
}
</script>
